@let formService = playSchedulingFormService;
<form class="main-content-container" [formGroup]="playSchedulingForm" (ngSubmit)="onSave()">
    <div class="schedule-settings-container">
        <div class="default-schedule-container">
            <r1-compass-lib-instructions headerText="Schedule">
                Optionally, enable Override Default Division Schedule to manually set the schedule for this play.
                Additionally, select dates to automatically start and/or expire this play if desired. If set, the play
                will first process records at the scheduled time on the start date and will automatically be disabled at
                the end of the day on the end date. Please note, the start and end dates are based on UTC.
            </r1-compass-lib-instructions>
        </div>
        <div class="schedule-input-container">
            <div class="general-toggle-container">
                <mat-slide-toggle
                    id="toggle-override-schedule"
                    (change)="formService.onOverrideScheduleToggled($event)"
                    [checked]="playSchedulingForm.controls.override.value"
                    >Override Default Schedule
                </mat-slide-toggle>
            </div>
            @if (playSchedulingForm.controls.override.value) {
                <div class="week-schedule-checkbox">
                    @for (day of days; track $index) {
                        <div class="schedule-box">
                            <mat-label class="schedule-label">{{ day }}</mat-label>
                            <mat-checkbox
                                [checked]="formService.inCheckedDays()[$index]"
                                (change)="formService.updateDaysOfTheWeekCheckbox($event, day)" />
                        </div>
                    }
                </div>
                <div class="time-and-offset">
                    <div class="time-and-offset-box">
                        <mat-form-field class="time-and-offset-field">
                            <mat-label>Start Time</mat-label>
                            <input
                                [ngxMatTimepicker]="picker"
                                matInput
                                [placeholder]="'Start Time'"
                                class="time-field"
                                [value]="formService.displayTime()" />
                            <ngx-mat-timepicker
                                #picker
                                [minutesGap]="5"
                                (timeSet)="formService.transformTimeFormat($event)" />
                        </mat-form-field>
                    </div>
                    <div class="time-and-offset-box">
                        <mat-form-field class="time-and-offset-field">
                            <mat-label>Offset</mat-label>
                            <mat-select
                                placeholder="Offset"
                                [value]="formService.displayOffset()"
                                (selectionChange)="formService.transformOffset($event)">
                                @for (offset of offsets; track $index) {
                                    <mat-option [value]="offset">
                                        {{ offset }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
                <div class="start-and-end-dates">
                    <div class="start-and-end-dates-box">
                        <mat-form-field class="start-and-end-dates-field">
                            <mat-label>Start Date</mat-label>
                            <input
                                matInput
                                [matDatepicker]="datePickerStart"
                                [formControl]="playSchedulingForm.controls.startDate"
                                (dateChange)="onDateChange($event, 'startDate')" />
                            <mat-datepicker-toggle matIconSuffix [for]="datePickerStart">
                                <fa-icon icon="calendar-alt" />
                            </mat-datepicker-toggle>
                            <mat-datepicker #datePickerStart />
                        </mat-form-field>
                    </div>
                    <div class="start-and-end-dates-box">
                        <mat-form-field class="start-and-end-dates-field">
                            <mat-label>End Date</mat-label>
                            <input
                                matInput
                                [formControl]="playSchedulingForm.controls.endDate"
                                [matDatepicker]="datePickerEnd"
                                (dateChange)="onDateChange($event, 'endDate')" />
                            <mat-datepicker-toggle matIconSuffix [for]="datePickerEnd">
                                <fa-icon icon="calendar-alt" />
                            </mat-datepicker-toggle>
                            <mat-datepicker #datePickerEnd />
                        </mat-form-field>
                    </div>
                </div>
            }
        </div>
    </div>
    <r1-compass-lib-divider />
    <div class="schedule-settings-container">
        <div class="default-schedule-container">
            <r1-compass-lib-instructions headerText="Run On Schedule">
                Toggle "Enabled" to begin sending Recommendations to Salesforce according to the default schedule or the
                override schedule above.
                @if (play()?.type === 'Builder') {
                    <span>The play must have an associated template criteria to run.</span>
                } @else {
                    <span>The play must have at least one file mapping to run.</span>
                }
            </r1-compass-lib-instructions>
        </div>
        <div class="schedule-input-container">
            <div class="general-toggle-container">
                <mat-slide-toggle
                    id="toggle-enable"
                    formControlName="isEnabled"
                    [checked]="playSchedulingForm.controls.isEnabled.value"
                    >{{ playSchedulingForm.controls.isEnabled.value ? 'Enabled' : 'Disabled' }}
                </mat-slide-toggle>
            </div>
            @if (nextScheduledTime()) {
                Next Run Time: {{ nextScheduledTime() }}
            }
            @if (enableErrorMessage()) {
                <div style="color: orange">{{ enableErrorMessage() }}</div>
            }
        </div>
    </div>
    <r1-compass-lib-divider />
    <div class="schedule-settings-container">
        <div class="default-schedule-container">
            <r1-compass-lib-instructions headerText="Run On Demand">
                To run this play once now, regardless of its enabled/disabled status above, click the Run Now button.
                This will otherwise not impact the play's regular schedule.
            </r1-compass-lib-instructions>
        </div>
        <div class="schedule-run-button-container">
            <div class="schedule-run-button-row-container">
                <div>
                    <button
                        mat-flat-button
                        id="schedule-run-button"
                        (click)="onRun()"
                        [disabled]="runNowDisabled()"
                        type="button">
                        Run Now
                    </button>
                    {{ runNowMessage() }}
                    @if (userHasResetStatusPermission()) {
                        <button
                            mat-flat-button
                            id="reset-status-button"
                            class="schedule-reset-button"
                            (click)="resetStatus()"
                            type="button">
                            Reset Status
                        </button>
                    }
                </div>
            </div>
            @if (runNowErrorMessage()) {
                <div style="color: orange">{{ runNowErrorMessage() }}</div>
            }
        </div>
    </div>
    <div class="button-container">
        <button
            mat-flat-button
            color="primary"
            class="schedule-save-button"
            type="submit"
            [disabled]="!playSchedulingForm.valid">
            Save
        </button>
    </div>
</form>
